import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CustomerPayload } from "./customerTypes"

export type EditCustomerRequest = CustomerPayload

export const editCustomer = async (
  customerId: string,
  params: EditCustomerRequest
) => {
  await api.put(`/beepaidgo/customers/${customerId}/`, {
    body: {
      ...params,
      email: params.email || null,
      phone: params.phone || null,
    },
  })

  queryClient.invalidateQueries([CUSTOMERS_QUERY_KEY])
}
